import React, { Component } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { AppContext } from "~/scripts/context/app";

class BodyCopy extends Component {
    static propTypes = {
        children: PropTypes.node
    };

    static contextType = AppContext;

    render() {
        const { children } = this.props;
        const { theme } = this.context;

        return (
            <div className={classNames("body-copy", `theme-${theme}`)}>
                {children}
            </div>
        );
    }
}

export default BodyCopy;



// WEBPACK FOOTER //
// ./src/scripts/components/BodyCopy.js